"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunaSenate = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Card_1 = require("../Card");
const Size_1 = require("../render/Size");
class LunaSenate extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.LUNA_SENATE,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.MOON],
            cost: 32,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.MOON, 3)),
            metadata: {
                description: 'Requires that you have 3 Moon tags. Increase your M€ production 1 step per Moon tag in the game (including these.)',
                cardNumber: 'M70',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.megacredits(1)).nbsp(Size_1.Size.TINY).slash().moon().played.any.br;
                    b.vpText('1 VP per Moon tag you have.');
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.moon(1, 1),
            },
        });
    }
    ;
    play(player) {
        const count = player.game.getPlayers().map((p) => p.getTagCount(Tags_1.Tags.MOON, p.id === player.id ? 'default' : 'raw')).reduce((p, v) => p + v, 0);
        player.addProduction(Resources_1.Resources.MEGACREDITS, count + 2, { log: true });
        return undefined;
    }
    getVictoryPoints(player) {
        return player.getTagCount(Tags_1.Tags.MOON, 'raw');
    }
}
exports.LunaSenate = LunaSenate;
//# sourceMappingURL=LunaSenate.js.map